import BestHub from "../../components/best/BestHub";

export { Page }

function Page() {
  return <BestHub />;
}